/**
 * routes.ts — Route helpers and path builders
 */

import { DASHBOARD_ROOT, DEFAULT_MODULE } from '@/lib/constants'

export function dashboardPath(path = ''): string {
  if (!path || path === '/') return DASHBOARD_ROOT
  return `${DASHBOARD_ROOT}${path.startsWith('/') ? path : `/${path}`}`
}

export function normalizeDashboardPath(path: string | null | undefined): string {
  if (!path) return DEFAULT_MODULE
  if (path === DASHBOARD_ROOT || path === `${DASHBOARD_ROOT}/`) return DEFAULT_MODULE
  if (path.startsWith(`${DASHBOARD_ROOT}/`)) return path
  return dashboardPath(path)
}

export const routes = {
  root: '/',
  dashboard: () => DASHBOARD_ROOT,

  kuroboard: {
    overview: () => dashboardPath('/kuroboard'),
    projects: () => dashboardPath('/kuroboard/projects'),
    project: (id: string) => dashboardPath(`/kuroboard/projects/${id}`),
    notifications: () => dashboardPath('/kuroboard/notifications'),
  },

  kurotrader: {
    overview: () => dashboardPath('/kurotrader'),
    performance: () => dashboardPath('/kurotrader/performance'),
    portfolio: () => dashboardPath('/kurotrader/portfolio'),
    signals: () => dashboardPath('/kurotrader/signals'),
  },

  gokuHealth: {
    overview: () => dashboardPath('/goku-health'),
    services: () => dashboardPath('/goku-health/services'),
    resources: () => dashboardPath('/goku-health/resources'),
    incidents: () => dashboardPath('/goku-health/incidents'),
  },

  kuroSite: {
    overview: () => dashboardPath('/kuro-site'),
    now: () => dashboardPath('/kuro-site/now'),
    posts: () => dashboardPath('/kuro-site/posts'),
    post: (slug: string) => dashboardPath(`/kuro-site/posts/${slug}`),
  },

  kuro: {
    overview: () => dashboardPath('/kuro'),
    about: () => dashboardPath('/kuro/about'),
    activity: () => dashboardPath('/kuro/activity'),
  },

  kurorunner: {
    overview: () => dashboardPath('/kurorunner'),
    job: (id: string) => dashboardPath(`/kurorunner/${id}`),
  },
} as const
